import React, { Component } from 'react';
import './square.css';

export default class Square extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    }
  }
  onMouseEnter() {

  }

  onMouseLeave() {

  }
  render() {
    let { children, className } = this.props;
    return (
      <div className={`ki-about-grid-square ${className}`}>
        {children}
      </div>
    );
  }
}
